module.exports = __webpack_public_path__ + "img/login.5427ade0.png";